import { Grid } from "@mui/material";

import { FormInput } from "../../../../components/hook-form/form-input.component";
import { DateFormat, FormDateField } from "../../../../components/hook-form/form-date.field.component";
import { FileUploadTextfield } from "../../../../components/hook-form/file-upload-textfield.component";
import { GuardedComponent } from "../../../../components/guarded-component";
import { UserPermissionName } from "../../../../models/user-permission-name";

interface ProctorResultForm {
    onFileUpload: (data: any) => void;
}
export const ProctorResultFormComponent = ({ onFileUpload }: ProctorResultForm) => {
    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormInput label="Proctor File Name" name="proctorFileName" autoFocus />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormDateField label="Proctor Date" name="proctorDate" format={DateFormat.SIMPLE_DATE} />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormInput label="Proctor File Number" name="fileNumber" />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormInput type='number' label="Dry Density" name="dryDensity" />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormInput type='number' label="Optimum Moisture Content" name="optimumMoistureContent" />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormInput label="Visual Soil Characteristics" name="visualSoilCharacteristics" />
                    </Grid>
                    {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
                                    <FormInput label="Uploaded File Name" name="uploadedFileName" />
                                </Grid> */}
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <GuardedComponent requiredPermissions={[UserPermissionName.UPLOAD_FILE]}>
                            <FileUploadTextfield
                                name='uploadedFile'
                                label='Uploaded File'
                                onChange={onFileUpload}
                            />
                        </GuardedComponent>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}